import { CALL_API } from '../store/api';

export const TLIST_REQUEST = 'TLIST_REQUEST';
export const TLIST_SUCCESS = 'TLIST_SUCCESS';
export const TLIST_FAILURE = 'TLIST_FAILURE';

export const TLIST_SEND_REQUEST = 'TLIST_SEND_REQUEST';
export const TLIST_SEND_SUCCESS = 'TLIST_SEND_SUCCESS';
export const TLIST_SEND_FAILURE = 'TLIST_SEND_FAILURE';

export const TLIST_REMOVE_REQUEST = 'TLIST_REMOVE_REQUEST';
export const TLIST_REMOVE_SUCCESS = 'TLIST_REMOVE_SUCCESS';
export const TLIST_REMOVE_FAILURE = 'TLIST_REMOVE_FAILURE';

export const VTLIST_REQUEST = 'VTLIST_REQUEST';
export const VTLIST_SUCCESS = 'VTLIST_SUCCESS';
export const VTLIST_FAILURE = 'VTLIST_FAILURE';

export const VTLIST_ADD_REQUEST = 'VTLIST_ADD_REQUEST';
export const VTLIST_ADD_SUCCESS = 'VTLIST_ADD_SUCCESS';
export const VTLIST_ADD_FAILURE = 'VTLIST_ADD_FAILURE';

export const VTLIST_DELETE_REQUEST = 'VTLIST_DELETE_REQUEST';
export const VTLIST_DELETE_SUCCESS = 'VTLIST_DELETE_SUCCESS';
export const VTLIST_DELETE_FAILURE = 'VTLIST_DELETE_FAILURE';

export const VTLIST_UPDATE_REQUEST = 'VTLIST_UPDATE_REQUEST';
export const VTLIST_UPDATE_SUCCESS = 'VTLIST_UPDATE_SUCCESS';
export const VTLIST_UPDATE_FAILURE = 'VTLIST_UPDATE_FAILURE';

export const NHLIST_REQUEST = 'NHLIST_REQUEST';
export const NHLIST_SUCCESS = 'NHLIST_SUCCESS';
export const NHLIST_FAILURE = 'NHLIST_FAILURE';

export const TASKS_REQUEST = 'TASKS_REQUEST';
export const TASKS_SUCCESS = 'TASKS_SUCCESS';
export const TASKS_FAILURE = 'TASKS_FAILURE';

export const fetchTickets = () => ({
    [CALL_API]: {
        types: [TLIST_REQUEST, TLIST_SUCCESS, TLIST_FAILURE],
        method: 'GET',
        endpoint: 'zendesk/getticketlist'
    }
});

export const fetchViolationTypes = () => ({
    [CALL_API]: {
        types: [VTLIST_REQUEST, VTLIST_SUCCESS, VTLIST_FAILURE],
        method: 'GET',
        endpoint: 'zendesk/getviolationtypelist'
    }
});

export const sendNotification = (body) => ({
    [CALL_API]: {
        types: [TLIST_SEND_REQUEST, TLIST_SEND_SUCCESS, TLIST_SEND_FAILURE],
        method: 'POST',
        endpoint: 'zendesk/sendnotification',
        body: body
    }
});

export const removeViolation = (body) => ({
    [CALL_API]: {
        types: [TLIST_REMOVE_REQUEST, TLIST_REMOVE_SUCCESS, TLIST_REMOVE_FAILURE],
        method: 'POST',
        endpoint: 'zendesk/removenotification',
        body: body
    }
});

export const addViolationType = (body) => ({
    [CALL_API]: {
        types: [VTLIST_ADD_REQUEST, VTLIST_ADD_SUCCESS, VTLIST_ADD_FAILURE],
        method: 'POST',
        endpoint: 'zendesk/addviolationtype',
        body: body
    }
});

export const deleteViolationType = (id) => ({
    [CALL_API]: {
        types: [VTLIST_DELETE_REQUEST, VTLIST_DELETE_SUCCESS, VTLIST_DELETE_FAILURE],
        method: 'DELETE',
        endpoint: 'zendesk/removeviolationtype/' + id
    }
});

export const updateViolationType = (body) => ({
    [CALL_API]: {
        types: [VTLIST_UPDATE_REQUEST, VTLIST_UPDATE_SUCCESS, VTLIST_UPDATE_FAILURE],
        method: 'POST',
        endpoint: 'zendesk/updateviolationtype',
        body: body
    }
});

export const fetchNotificationList = (ticketId) => ({
    [CALL_API]: {
        types: [NHLIST_REQUEST, NHLIST_SUCCESS, NHLIST_FAILURE],
        method: 'GET',
        endpoint: 'zendesk/getnotificationlist/' + ticketId
    }
});

export const fetchTasks = () => ({
    [CALL_API]: {
        types: [TASKS_REQUEST, TASKS_SUCCESS, TASKS_FAILURE],
        method: 'GET',
        endpoint: 'zendesk/getpendingapprovallist'
    }
});